import React, { useRef } from 'react';
import { HeroSection, HeroPrimaryButton } from './types';
import { LabelRow, SplitRow, DraftTextField } from './primitives';

interface HeroEditorProps {
  data:     HeroSection;
  onChange: (v: HeroSection) => void;
}

const HeroEditor: React.FC<HeroEditorProps> = ({ data, onChange }) => {
  const orig   = useRef(data);
  const set    = (p: Partial<HeroSection>) => onChange({ ...data, ...p });
  const setBtn = (p: Partial<HeroPrimaryButton>) =>
    onChange({ ...data, primaryButton: { ...data.primaryButton, ...p } });

  return (
    <>
      <LabelRow label="Main title" />
      <SplitRow currentText={orig.current.headline}>
        <DraftTextField placeholder="Payment specialist"
          onChange={v => set({ headline: v })} />
      </SplitRow>

      <LabelRow label="Primary button"
        toggle={{ checked: data.primaryButton.visible, onChange: v => setBtn({ visible: v }) }}
      />
      <SplitRow currentText={orig.current.primaryButton.label}>
        <DraftTextField placeholder="View detail"
          onChange={v => setBtn({ label: v })} />
      </SplitRow>
    </>
  );
};

export default HeroEditor;